import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=b4c2390e&"
var script = {}
import style0 from "./Personal.vue?vue&type=style&index=0&id=b4c2390e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports